module.exports = __webpack_public_path__ + "img/zlindex21.5ad5b00f.png";